// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PorticoGetPortalConfigurationDefaultResponse {
    static getAttributeTypeMap() {
        return PorticoGetPortalConfigurationDefaultResponse.attributeTypeMap;
    }
}
PorticoGetPortalConfigurationDefaultResponse.discriminator = undefined;
PorticoGetPortalConfigurationDefaultResponse.additionalProperties = false;
PorticoGetPortalConfigurationDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetPortalConfigurationResponseModel"
    },
];
//# sourceMappingURL=porticoGetPortalConfigurationDefaultResponse.js.map